import type { AgentRun } from "./contracts";
import { authorizedFetch, newIdempotencyKey, request } from "./transport";

export interface AgentRunArtifact {
  id: string;
  run_id: string;
  kind: string;
  filename: string;
  content_type: string;
  size: number;
  checksum_sha256: string;
  truncated: boolean;
  created_at: string;
}

export async function create(boardId?: string, ticketId?: string): Promise<AgentRun> {
  return (
    await request<AgentRun>(
      "POST",
      "/api/v1/admin/agent-runs/diagnostic",
      {
        ...(boardId ? { board_id: boardId } : {}),
        ...(ticketId ? { ticket_id: ticketId } : {}),
      },
      { idempotencyKey: newIdempotencyKey() },
    )
  ).body;
}

export async function get(runId: string): Promise<AgentRun> {
  return (await request<AgentRun>("GET", `/api/v1/admin/agent-runs/${runId}`)).body;
}

export async function artifacts(runId: string): Promise<AgentRunArtifact[]> {
  return (
    await request<AgentRunArtifact[]>(
      "GET",
      `/api/v1/admin/agent-runs/${runId}/artifacts`,
    )
  ).body;
}

export async function artifactText(runId: string, artifactId: string): Promise<string> {
  const response = await authorizedFetch(
    `/api/v1/admin/agent-runs/${runId}/artifacts/${artifactId}`,
  );
  if (!response.ok) throw new Error("Artifact download failed");
  return response.text();
}

export async function cancel(run: AgentRun): Promise<AgentRun> {
  return (
    await request<AgentRun>(
      "POST",
      `/api/v1/admin/agent-runs/${run.id}/cancel`,
      undefined,
      { etag: run.version, idempotencyKey: newIdempotencyKey() },
    )
  ).body;
}
